export default __webpack_public_path__ + "static/media/LogoWhite.0b6e993a.png";